import { toast } from "react-toastify";
import { BULK_USERS_UPLOAD_FORMAT, BULK_USERS_UPLOAD_FORMAT_TRIV, defaultBusiness, defaultVertical, defaultZone, HRF_BUSINESS_VERTICAL_ID, TENANTS } from "../../../config/constant";
import { MasterService } from "../../../services";

export const getCreateOrUpdateUserPayload = async ({ TENANT, user_detail, basic_details, role_details, profile_data, modified_documents, state_data, city_data, user_logout, illumaVerificationDetails }) => {
    let payload = {
        created_date: basic_details.created_date && isNaN(Date.parse(basic_details.created_date)) === false ? new Date(basic_details.created_date) : "",
        approval_date: basic_details.approval_date && isNaN(Date.parse(basic_details.approval_date)) === false ? new Date(basic_details.approval_date) : "",
        resign_date_1: basic_details.resign_date_1 && isNaN(Date.parse(basic_details.resign_date_1)) === false ? new Date(basic_details.resign_date_1) : "",
        resign_date_2: basic_details.resign_date_2 && isNaN(Date.parse(basic_details.resign_date_2)) === false ? new Date(basic_details.resign_date_2) : "",
        rejoin_date_1: basic_details.rejoin_date_1 && isNaN(Date.parse(basic_details.rejoin_date_1)) === false ? new Date(basic_details.rejoin_date_1) : "",
        rejoin_date_2: basic_details.rejoin_date_2 && isNaN(Date.parse(basic_details.rejoin_date_2)) === false ? new Date(basic_details.rejoin_date_2) : "",
        warning_date_1: basic_details.warning_date_1 && isNaN(Date.parse(basic_details.warning_date_1)) === false ? new Date(basic_details.warning_date_1) : "",
        warning_date_2: basic_details.warning_date_2 && isNaN(Date.parse(basic_details.warning_date_2)) === false ? new Date(basic_details.warning_date_2) : "",
        onboarded_from: basic_details.user_source ? basic_details.user_source : "",
        onboarded_by: basic_details.name ? basic_details.name : "",
        hiring_source: basic_details.hiring_source ? basic_details.hiring_source : "",
        comments: basic_details.comments ? basic_details.comments : "",
        name: basic_details.username,
        employee_id: basic_details.employee_id ? basic_details.employee_id : "",
        role: role_details.role,
        bank_id: basic_details.bank_id,
        bank_account_number: basic_details.bank_account_number,
        confirm_bank_account_number: basic_details.bank_account_number,
        beneficiary_name: basic_details.beneficiary_name,
        bank_branch_name: basic_details.bank_branch_name,
        npwp: basic_details.npwp ? basic_details.npwp : "",
        document_info: modified_documents,
        state: state_data,
        city: city_data,
        zone_id: defaultZone,
        business_line: role_details.business_line,
        joining_date: basic_details.joining_date,
        date_of_birth: basic_details.date_of_birth,
        anniversary_date: basic_details.anniversary_date,
        address: basic_details.address ? basic_details.address : "",
        street_address: basic_details.street_address ? basic_details.street_address : "",
        house_no: basic_details.house_number ? basic_details.house_number : "",
        user_state: basic_details.state_name,
        user_city: basic_details.city,
        pincode: basic_details.postal_code,
        incentive_percentage: basic_details.incentive_percentage ? basic_details.incentive_percentage.toString() : "",
        is_tax_booster_enable: basic_details.is_tax_booster_enable ? '1' : '0',
        email_id: basic_details.email_id,
        password: basic_details.password,
        current_password: basic_details.current_password ? basic_details.current_password : "",
        change_password: basic_details.change_password ? basic_details.change_password : false,
        mobile_no: basic_details.mobile_no,
        ktp_id: basic_details.ktp_id,
        reporting_role: role_details.reporting_role ? role_details.reporting_role : 0,
        reporting_manager: role_details.reporting_manager ? role_details.reporting_manager : 0,
        secondary_reporting_role: role_details.secondary_reporting_role ? role_details.secondary_reporting_role : 0,
        secondary_reporting_manager: role_details.secondary_reporting_manager ? role_details.secondary_reporting_manager : 0,
        current_occupation: basic_details.current_occupation ? basic_details.current_occupation : "",
        company_name: basic_details.company_name ? basic_details.company_name : "",
        company_address: basic_details.company_address ? basic_details.company_address : "",
        source_id: basic_details.source ? basic_details.source : "",
        rw: basic_details.rw ? basic_details.rw : "",
        rt: basic_details.rt ? basic_details.rt : "",
        employment_type: basic_details.employment_type ? basic_details.employment_type : "",
        designation_id: basic_details.designation ? basic_details.designation : "",
        user_location: basic_details.user_location ? basic_details.user_location : "",
        tagging_id: basic_details.tagging_id ? basic_details.tagging_id : "",
        referral_name: basic_details.referral_name ? basic_details.referral_name : "",
        bm_grading: basic_details.bm_grading ? basic_details.bm_grading : '',
        user_logout: user_logout,
        agent_wallet: basic_details.agent_wallet ? basic_details.agent_wallet : 0,
        is_subscribe_dif: basic_details.is_subscribe_dif && basic_details.is_subscribe_dif === 1 ? 1 : 0,
        alternative_number: basic_details.alternative_number ? basic_details.alternative_number : 0,
        whatsapp_mobile_number: basic_details.whatsapp_mobile_number ? basic_details.whatsapp_mobile_number : 0,
        eca_agent: basic_details.eca_agent ? basic_details.eca_agent : 0,
        sss_id_number: basic_details.sss_id_number,
        tin_id: basic_details.tin_id ? basic_details.tin_id : "",
        aro_so_assigned: basic_details.aro_so_assigned ? basic_details.aro_so_assigned : "",
        territory_id: basic_details.territory_id ? basic_details.territory_id : 0,
        is_dsa: basic_details.is_dsa && basic_details.is_dsa === 1 ? 1 : 0,
        business_unit_id: role_details.business_unit_id ?? defaultBusiness,
        birth_place_state_id: basic_details.birth_place_state_id ? basic_details.birth_place_state_id : "",
        birth_place_city_id: basic_details.birth_place_city_id ? basic_details.birth_place_city_id : "",
        blood_type_id: basic_details.blood_type_id ? basic_details.blood_type_id : "",
        father_name: basic_details.father_name ? basic_details.father_name : "",
        mother_name: basic_details.mother_name ? basic_details.mother_name : "",
        marital_status_id: basic_details.marital_status_id ? basic_details.marital_status_id : "",
        gender_id: basic_details.gender_id ? basic_details.gender_id : "",
        business_vertical_id: role_details.business_vertical_id ?? defaultVertical
    }
    if (TENANT !== TENANTS.PH) payload.is_illuma_verified = basic_details.is_illuma_verified;

    if (user_detail.user_id) {
        payload.user_id = user_detail.user_id
        payload.status = user_detail.status
    }

    if (profile_data && Object.keys(profile_data).length > 0) {
        payload.profile_image_name = profile_data.profile_image_name ? profile_data.profile_image_name : ""
        payload.profile_image_path = profile_data.profile_image_path ? profile_data.profile_image_path : ""
    }

    if (TENANT !== TENANTS.PH && payload.business_vertical_id !== HRF_BUSINESS_VERTICAL_ID) {
        let cbi_doc_url = await uploadCbiCreditDoc(basic_details, user_detail?.user_id ?? 0);
        payload.cbi_credit_info = {
            credit_score: basic_details.credit_score ? parseInt(basic_details.credit_score) : null,
            default_probability: basic_details.default_probability ? parseFloat(basic_details.default_probability) : null,
            current_loan_type_id: basic_details.current_loan_type_id,
            current_loan_type_others: basic_details.current_loan_type_others,
            past_loan_type_id: basic_details.past_loan_type_id,
            past_loan_type_others: basic_details.past_loan_type_others,
            cbi_doc_url: cbi_doc_url ?? null,
        }

    }

    if([TENANTS.FAV, TENANTS.OTO].includes(TENANT) && payload.business_vertical_id === HRF_BUSINESS_VERTICAL_ID){
        let hrfDocumentPayload = await getHrfDocumentPayload(basic_details, user_detail);
        payload.hrf_documents = {
            nib_document_url: hrfDocumentPayload.nib_document_url ?? null,
            npwp_perusahaan_url: hrfDocumentPayload.npwp_perusahaan_url ?? null,
         }
    }

    return payload;

}


const uploadCbiCreditDoc = async (basic_details, user_id) => {
    let url = basic_details.cbi_doc_url ?? null;

    if (basic_details.cbi_doc_file) {
        let formData = new FormData();
        formData.append("upload_type", "sfa_docs");
        formData.append("visit_id", `user/${user_id}`);
        formData.append("images", basic_details.cbi_doc_file);
        let result = await MasterService.uploadFilesToS3(formData, { "Content-Type": "multipart/form-data", });

        if (result.data.status === 200) {
            url = result.data.data[0].file_url;
            toast.success("CBI document uploaded")
        }
    }
    return url
}

export const isBeneficiaryNameDisabled = ({ TENANT, adminRoleId, ADMIN_ROLES, userDetail, enableBankInfo, illumaVerificationDetails }) => {
  if (adminRoleId === ADMIN_ROLES['super_admin'] || TENANT === TENANTS.PH) return false;

  if (illumaVerificationDetails?.disabled) return true;

  const hasBankDetails = userDetail?.basic_details?.bank_account_number && userDetail?.basic_details?.beneficiary_name;

  return hasBankDetails ? !enableBankInfo : false;
};

const resetMap = {
        business_line: [ 'reporting_role', 'reporting_manager', 'secondary_reporting_role', 'secondary_reporting_manager'],
        business_unit_id: ['role', 'reporting_role', 'reporting_manager', 'secondary_reporting_role', 'secondary_reporting_manager', 'business_line', 'business_vertical_id' ],
        business_vertical_id: ['role', 'business_line', 'reporting_role', 'reporting_manager', ]
    };

export const resetFieldsByName = (name, object = {}) => {
    let tempObject = { ...object };
    if (resetMap[name]) {
        resetMap[name].forEach(field => { tempObject[field] = "";  });
    }

    return tempObject;
};

export const getHrfDocumentPayload = async (basic_details, user_detail) => {
    let hrf_docs_urls = await uploadHrfDocs(basic_details, user_detail?.user_id ?? 0);
    return {
        nib_document_url: hrf_docs_urls.nib_document_url || null,
        npwp_perusahaan_url: hrf_docs_urls.npwp_perusahaan_url || null,
    }
}       

const uploadHrfDocs = async (basic_details, user_id) => {
    let urls = {
        nib_document_url: basic_details.nib_document_url ?? null,
        npwp_perusahaan_url: basic_details.npwp_perusahaan_url ?? null
    };

    if (basic_details.nib_document_file) {
        let formData = new FormData();
        formData.append("upload_type", "sfa_docs");
        formData.append("visit_id", `user/${user_id}`);
        formData.append("images", basic_details.nib_document_file);
        formData.append("upload_doc_type", "home-loan");
        let result = await MasterService.uploadFilesToS3(formData, { "Content-Type": "multipart/form-data" });

        if (result.data.status === 200) {
            urls.nib_document_url = result.data.data[0].file_url;
            toast.success("NIB document uploaded")
        }
    }

    if (basic_details.npwp_perusahaan_file) {
        let formData = new FormData();
        formData.append("upload_type", "sfa_docs");
        formData.append("visit_id", `user/${user_id}`);
        formData.append("images", basic_details.npwp_perusahaan_file);
        formData.append("upload_doc_type", "home-loan");
        let result = await MasterService.uploadFilesToS3(formData, { "Content-Type": "multipart/form-data" });

        if (result.data.status === 200) {
            urls.npwp_perusahaan_url = result.data.data[0].file_url;
            toast.success("NPWP perusahaan uploaded")
        }
    }

    return urls
}


export const getTenantWiseBulkUsersUploadFormat = (tenant=TENANTS.OTO) => {
    if(tenant === TENANTS.TRIV) return BULK_USERS_UPLOAD_FORMAT_TRIV
    return BULK_USERS_UPLOAD_FORMAT
}